import http from 'utils/http';
import { getBusinessApiKeyNewUrl, getBusinessApiKeysUrl, getBusinessApiKeyUrl } from './apiUrls';
import { BusinessApiKey, BusinessApiKeyNewResponse, BusinessApiKeyRequest, BusinessApiKeysListResponse } from './types';

export function getBusinessApiKeys(params?: Record<string, unknown>): Promise<BusinessApiKeysListResponse> {
  return http.get(getBusinessApiKeysUrl(), params);
}

export function getBusinessApiKeyNew(): Promise<BusinessApiKeyNewResponse> {
  return http.get(getBusinessApiKeyNewUrl());
}

export function createBusinessApiKey(payload: BusinessApiKeyRequest): Promise<BusinessApiKey> {
  return http.post(getBusinessApiKeysUrl(), payload);
}

export function deleteBusinessApiKey(id: number | string): Promise<{ meta: { message: string } }> {
  return http.delete(getBusinessApiKeyUrl(id));
}
